module.exports = __webpack_public_path__ + "img/icon3.e538ef5b.svg";